module.exports = __webpack_public_path__ + "static/media/005_service_mesh_viewer.c41b616b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/googlecloud/005_service_mesh_viewer.png
// module id = 469
// module chunks = 0